var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"octicon",staticStyle:{"width":"1em","height":"1em"},attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":`#icon-${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }